export enum ResourceType {
  OrganizationAudit = 'organization_audit',
  OrganizationAuthSettings = 'organization_auth_settings',
  OrganizationBillingSettings = 'organization_billing_settings',
  OrganizationDefaultLicensingPolicy = 'organization_default_licensing_policy',
  OrganizationDefaultQualityPolicy = 'organization_default_quality_policy',
  OrganizationDefaultSBOMPolicy = 'organization_default_sbom_policy',
  OrganizationDefaultSecurityPolicy = 'organization_default_security_policy',
  OrganizationGeneralSettings = 'organization_general_settings',
  OrganizationIntegrationSettings = 'organization_integration_settings',
  OrganizationLanguageSettings = 'organization_language_settings',
  OrganizationOIDCProvider = 'organization_oidc_provider',
  OrganizationPortalReports = 'organization_portal_reports',
  OrganizationPortalSettings = 'organization_portal_settings',
  OrganizationReport = 'organization_report',
  OrganizationServiceAccountTrustRelationship = 'organization_service_account_trust_relationship',

  ProjectAny = 'project_any',
  Project = 'project',

  ProjectLicensingIssue = 'project_licensing_issue',
  ProjectLicensingIssueAny = 'project_licensing_issue_any',
  ProjectLicensingPolicy = 'project_licensing_policy',
  ProjectLicensingPolicyAny = 'project_licensing_policy_any',
  ProjectLicensingReportPublicLink = 'project_licensing_report_public_link',
  ProjectLicensingReportPublicLinkAny = 'project_licensing_report_public_link_any',
  ProjectQualityIssue = 'project_quality_issue',
  ProjectQualityIssueAny = 'project_quality_issue_any',
  ProjectQualityPolicy = 'project_quality_policy',
  ProjectQualityPolicyAny = 'project_quality_policy_any',
  ProjectSBOMPolicy = 'project_sbom_policy',
  ProjectSBOMPolicyAny = 'project_sbom_policy_any',
  ProjectSecurityIssue = 'project_security_issue',
  ProjectSecurityIssueAny = 'project_security_issue_any',
  ProjectSecurityPolicy = 'project_security_policy',
  ProjectSecurityPolicyAny = 'project_security_policy_any',

  ReleaseGroupAny = 'release_group_any',
  ReleaseGroup = 'release_group',

  ReleaseGroupRelease = 'release_group_release',
  ReleaseGroupReleaseAny = 'release_group_release_any',

  ReleaseGroupLicensingIssue = 'release_group_licensing_issue',
  ReleaseGroupLicensingIssueAny = 'release_group_licensing_issue_any',
  ReleaseGroupLicensingPolicy = 'release_group_licensing_policy',
  ReleaseGroupLicensingPolicyAny = 'release_group_licensing_policy_any',
  ReleaseGroupQualityIssue = 'release_group_quality_issue',
  ReleaseGroupQualityIssueAny = 'release_group_quality_issue_any',
  ReleaseGroupQualityPolicy = 'release_group_quality_policy',
  ReleaseGroupQualityPolicyAny = 'release_group_quality_policy_any',
  ReleaseGroupSecurityIssue = 'release_group_security_issue',
  ReleaseGroupSecurityIssueAny = 'release_group_security_issue_any',
  ReleaseGroupSecurityPolicy = 'release_group_security_policy',
  ReleaseGroupSecurityPolicyAny = 'release_group_security_policy_any',

  Role = 'role',

  TeamAny = 'team_any',
  Team = 'team',
  TeamOIDCProvider = 'team_oidc_provider',
  TeamProject = 'team_project',
  TeamProjectAny = 'team_project_any',
  TeamReleaseGroupAny = 'team_release_group_any',
  TeamReleaseGroup = 'team_release_group',
  TeamServiceAccountTrustRelationship = 'team_service_account_trust_relationship',
  TeamUserAny = 'team_user_any',
  TeamUser = 'team_user',
  TeamReport = 'team_report',
  TeamReportOptionAny = 'team_report_option_any',

  LicensingPolicyAny = 'licensing_policy_any',
  LicensingPolicy = 'licensing_policy',
  SecurityPolicyAny = 'security_policy_any',
  SecurityPolicy = 'security_policy',
  QualityPolicyAny = 'quality_policy_any',
  QualityPolicy = 'quality_policy',
  SBOMPolicyAny = 'sbom_policy_any',
  SBOMPolicy = 'sbom_policy',

  User = 'user',
  UserAny = 'user_any',

  Label = 'label',

  IssueFilterLicensing = 'issue_filter_licensing',
  IssueFilterQuality = 'issue_filter_quality',
  IssueFilterSecurity = 'issue_filter_security',

  ProjectIssueFilterLicensing = 'project_issue_filter_licensing',
  ProjectIssueFilterQuality = 'project_issue_filter_quality',
  ProjectIssueFilterSecurity = 'project_issue_filter_security',

  ProjectIssueFilterLicensingAny = 'project_issue_filter_licensing_any',
  ProjectIssueFilterQualityAny = 'project_issue_filter_quality_any',
  ProjectIssueFilterSecurityAny = 'project_issue_filter_security_any',

  PackageLabel = 'package_label',
  ProjectPackageLabel = 'project_package_label',

  ProjectReport = 'project_report',
  ProjectReportAny = 'project_report_any',

  ReleaseGroupReport = 'release_group_report',
  ReleaseGroupReportAny = 'release_group_report_any',

  ReportOptionAny = 'report_option_any',

  ServiceAccount = 'service_account',
  ServiceAccountTeam = 'team_service_account',
}

export enum Action {
  Add = 'add',
  Comment = 'comment',
  Create = 'create',
  Delete = 'delete',
  Edit = 'edit',
  Invite = 'invite',
  MakePublic = 'make_public',
  Manage = 'manage',
  Remove = 'remove',
  Resolve = 'resolve',
  Export = 'export',
  Set = 'set',
  SetLocal = 'set_local',
  View = 'view',
}

export type IssueFilterLicensingActions = Action.Delete | Action.Create | Action.Edit;
export type IssueFilterQualityActions = Action.Delete | Action.Create | Action.Edit;
export type IssueFilterSecurityActions = Action.Delete | Action.Create | Action.Edit;
export type LabelActions = Action.Delete | Action.Create;
export type LicensingPolicyAnyActions = Action.Delete | Action.Edit | Action.View;
export type LicensingPolicyOrgActions = Action.Create;
export type OrganizationAuditActions = Action.View;
export type OrganizationAuthSettingsActions = Action.Edit;
export type OrganizationBillingSettingsActions = Action.Edit;
export type OrganizationDefaultLicensingPolicyActions = Action.Set;
export type OrganizationDefaultQualityPolicyActions = Action.Set;
export type OrganizationDefaultSBOMPolicyActions = Action.Set;
export type OrganizationDefaultSecurityPolicyActions = Action.Set;
export type OrganizationGeneralSettingsActions = Action.Edit | Action.View;
export type OrganizationIntegrationSettingsActions = Action.Edit;
export type OrganizationLanguageSettingsActions = Action.Edit | Action.View;
export type OrganizationOIDCProviderActions = Action.Manage | Action.View;
export type OrganizationPortalReportsActions = Action.Manage;
export type OrganizationPortalSettingsActions = Action.Edit | Action.View;
export type OrganizationReportActions = Action.Create;
export type OrganizationServiceAccountTrustRelationshipActions = Action.Manage | Action.View;
export type PackageLabelActions = Action.Create | Action.Delete | Action.Set;
export type PackageLabelTeamActions = Action.SetLocal;
export type ProjectActions = Action.Create | Action.Delete | Action.Edit | Action.MakePublic | Action.View;
export type ProjectAnyActions = Action.View | Action.Edit | Action.Delete | Action.MakePublic;
export type ProjectIssueFilterLicensingActions = Action.Edit;
export type ProjectIssueFilterLicensingAnyActions = Action.Edit;
export type ProjectIssueFilterQualityActions = Action.Edit;
export type ProjectIssueFilterQualityAnyActions = Action.Edit;
export type ProjectIssueFilterSecurityActions = Action.Edit;
export type ProjectIssueFilterSecurityAnyActions = Action.Edit;
export type ProjectLicensingIssueActions = Action.Comment | Action.Resolve | Action.Export | Action.View;
export type ProjectLicensingIssueAnyActions = Action.View | Action.Comment | Action.Resolve | Action.Export;
export type ProjectLicensingPolicyActions = Action.Set;
export type ProjectLicensingPolicyAnyActions = Action.Set;
export type ProjectLicensingReportPublicLinkActions = Action.Create;
export type ProjectLicensingReportPublicLinkAnyActions = Action.Create;
export type ProjectOrgActions = Action.Create;
export type ProjectQualityIssueActions = Action.Comment | Action.Resolve | Action.Export | Action.View;
export type ProjectQualityIssueAnyActions = Action.View | Action.Comment | Action.Resolve | Action.Export;
export type ProjectQualityPolicyActions = Action.Set;
export type ProjectQualityPolicyAnyActions = Action.Set;
export type ProjectReportActions = Action.Create;
export type ProjectReportAnyActions = Action.Create;
export type ProjectSBOMPolicyActions = Action.Create | Action.Delete | Action.Edit | Action.Set | Action.View;
export type ProjectSBOMPolicyAnyActions = Action.Create | Action.Delete | Action.Edit | Action.Set | Action.View;
export type ProjectSecurityIssueActions = Action.Comment | Action.Resolve | Action.Export | Action.View;
export type ProjectSecurityIssueAnyActions = Action.Comment | Action.Resolve | Action.Export | Action.View;
export type ProjectSecurityPolicyAnyActions = Action.Set;
export type ProjectSecurityPolicyOrgActions = Action.Set;
export type QualityPolicyAnyActions = Action.Delete | Action.Edit | Action.View;
export type QualityPolicyOrgActions = Action.Create;
export type ReleaseGroupActions = Action.View | Action.Edit | Action.Create | Action.Delete;
export type ReleaseGroupAnyActions = Action.View | Action.Delete | Action.Edit;
export type ReleaseGroupLicensingIssueActions = Action.Comment | Action.Resolve | Action.Export | Action.View;
export type ReleaseGroupLicensingIssueAnyActions = Action.Comment | Action.Resolve | Action.Export | Action.View;
export type ReleaseGroupLicensingPolicyActions = Action.Set;
export type ReleaseGroupLicensingPolicyAnyActions = Action.Set;
export type ReleaseGroupOrgActions = Action.Create;
export type ReleaseGroupQualityIssueActions = Action.Comment | Action.Resolve | Action.Export | Action.View;
export type ReleaseGroupQualityIssueAnyActions = Action.Comment | Action.Resolve | Action.Export | Action.View;
export type ReleaseGroupQualityPolicyActions = Action.Set;
export type ReleaseGroupQualityPolicyAnyActions = Action.Set;
export type ReleaseGroupReleaseActions = Action.Create | Action.Edit;
export type ReleaseGroupReleaseAnyActions = Action.Create | Action.Edit;
export type ReleaseGroupReportActions = Action.Create;
export type ReleaseGroupReportAnyActions = Action.Create;
export type ReportOptionAnyActions = Action.Create | Action.Edit | Action.Delete;
export type ReleaseGroupSecurityIssueActions = Action.Comment | Action.Resolve | Action.Export | Action.View;
export type ReleaseGroupSecurityIssueAnyActions = Action.Comment | Action.Resolve | Action.Export | Action.View;
export type ReleaseGroupSecurityPolicyActions = Action.Set;
export type ReleaseGroupSecurityPolicyAnyActions = Action.Set;
export type RoleActions = Action.Manage;
export type SBOMPolicyAnyActions = Action.View | Action.Delete | Action.View;
export type SBOMPolicyOrgActions = Action.Create | Action.Delete | Action.Edit | Action.Set | Action.View;
export type SecurityPolicyAnyActions = Action.Delete | Action.Edit | Action.View;
export type SecurityPolicyOrgActions = Action.Create;
export type TeamActions = Action.Edit | Action.View;
export type TeamAnyActions = Action.View | Action.Delete | Action.Edit;
export type TeamOIDCProviderActions = Action.Manage | Action.View;
export type TeamOrgActions = Action.Create;
export type TeamProjectActions = Action.Add | Action.Remove;
export type TeamProjectAnyActions = Action.Add | Action.Remove;
export type TeamReleaseGroupActions = Action.Add | Action.Remove;
export type TeamReleaseGroupAnyActions = Action.Add | Action.Remove;
export type TeamReportActions = Action.Create;
export type TeamReportOptionAnyActions = Action.Create | Action.Edit | Action.Delete;
export type TeamServiceAccountTrustRelationshipActions = Action.Manage | Action.View;
export type TeamUserActions = Action.Edit;
export type TeamUserAnyActions = Action.Edit;
export type UserActions = Action.Invite;
export type UserAnyActions = Action.View | Action.Remove;
export type ServiceAccountActions = Action.Manage;
export type ServiceAccountTeamActions = Action.Manage;

type BaseOrgPermission<TResource extends ResourceType, TAction extends Action> = {
  resourceType: TResource;
  action: TAction;
  projectId?: never;
  releaseGroupId?: never;
  teamId?: never;
};

/*
 * In `getUserPermissions.ts` we build the project/release group/team scoped permissions by querying for resource types
 * that begin with the scope name. If the resource type does not begin with the scope name then it will be considered as
 * an org-scoped permission and will not have a projectId, releaseGroupId, or teamId.
 */

type BaseProjectPermission<TResource extends `project${string}`, TAction extends Action> = {
  resourceType: TResource;
  action: TAction;
  projectId: string;
  releaseGroupId?: never;
  teamId?: never;
};

type BaseTeamPermission<TResource extends `team${string}` | ResourceType.Project, TAction extends Action> = {
  resourceType: TResource;
  action: TAction;
  projectId?: never;
  releaseGroupId?: never;
  teamId: number;
};

type BaseReleaseGroupPermission<TResource extends `release_group${string}`, TAction extends Action> = {
  resourceType: TResource;
  action: TAction;
  projectId?: never;
  releaseGroupId: number;
  teamId?: never;
};

/**
 * Permissions represented by ResourceType and Action combinations. All Permissions are
 * in the format of
 * ```
 * {
 *   resourceType: ResourceType;
 *   action: Action;
 *   projectId?: string | null;
 *   releaseGroupId?: number | null;
 *   teamId?: number | null;
 * }
 * ```
 */
export type Permission =
  /*
   *
   * Issue Filter Permissions
   *
   */
  | BaseOrgPermission<ResourceType.IssueFilterLicensing, IssueFilterLicensingActions>
  | BaseOrgPermission<ResourceType.IssueFilterQuality, IssueFilterQualityActions>
  | BaseOrgPermission<ResourceType.IssueFilterSecurity, IssueFilterSecurityActions>
  /**
   * OIDC Provider Permissions
   *
   */
  | BaseOrgPermission<ResourceType.OrganizationOIDCProvider, OrganizationOIDCProviderActions>
  | BaseTeamPermission<ResourceType.TeamOIDCProvider, TeamOIDCProviderActions>
  /*
   *
   * Organization Settings Permissions
   *
   */
  | BaseOrgPermission<ResourceType.OrganizationAudit, OrganizationAuditActions>
  | BaseOrgPermission<ResourceType.OrganizationAuthSettings, OrganizationAuthSettingsActions>
  | BaseOrgPermission<ResourceType.OrganizationBillingSettings, OrganizationBillingSettingsActions>
  | BaseOrgPermission<ResourceType.OrganizationDefaultLicensingPolicy, OrganizationDefaultLicensingPolicyActions>
  | BaseOrgPermission<ResourceType.OrganizationDefaultQualityPolicy, OrganizationDefaultQualityPolicyActions>
  | BaseOrgPermission<ResourceType.OrganizationDefaultSBOMPolicy, OrganizationDefaultSBOMPolicyActions>
  | BaseOrgPermission<ResourceType.OrganizationDefaultSecurityPolicy, OrganizationDefaultSecurityPolicyActions>
  | BaseOrgPermission<ResourceType.OrganizationGeneralSettings, OrganizationGeneralSettingsActions>
  | BaseOrgPermission<ResourceType.OrganizationIntegrationSettings, OrganizationIntegrationSettingsActions>
  | BaseOrgPermission<ResourceType.OrganizationLanguageSettings, OrganizationLanguageSettingsActions>
  | BaseOrgPermission<ResourceType.OrganizationPortalSettings, OrganizationPortalSettingsActions>
  /*
   *
   * Organization Report Permissions
   *
   */
  | BaseOrgPermission<ResourceType.OrganizationReport, OrganizationReportActions>
  | BaseOrgPermission<ResourceType.OrganizationPortalReports, OrganizationPortalReportsActions>
  /*
   *
   * Project/Package Label Permissions
   *
   */
  | BaseOrgPermission<ResourceType.Label, LabelActions>
  | BaseOrgPermission<ResourceType.PackageLabel, PackageLabelActions>
  | BaseProjectPermission<ResourceType.ProjectPackageLabel, PackageLabelTeamActions>
  /*
   *
   * Project CRUD Permissions
   *
   */
  | BaseProjectPermission<ResourceType.Project, ProjectActions>
  | BaseOrgPermission<ResourceType.Project, ProjectOrgActions>
  | BaseOrgPermission<ResourceType.ProjectAny, ProjectAnyActions>
  | BaseTeamPermission<ResourceType.Project, Action.Create>
  /*
   *
   * Project Issue Filter Permissions
   *
   */
  | BaseOrgPermission<ResourceType.ProjectIssueFilterLicensing, ProjectIssueFilterLicensingActions>
  | BaseOrgPermission<ResourceType.ProjectIssueFilterLicensingAny, ProjectIssueFilterLicensingAnyActions>
  | BaseOrgPermission<ResourceType.ProjectIssueFilterQuality, ProjectIssueFilterQualityActions>
  | BaseOrgPermission<ResourceType.ProjectIssueFilterQualityAny, ProjectIssueFilterQualityAnyActions>
  | BaseOrgPermission<ResourceType.ProjectIssueFilterSecurity, ProjectIssueFilterSecurityActions>
  | BaseOrgPermission<ResourceType.ProjectIssueFilterSecurityAny, ProjectIssueFilterSecurityAnyActions>
  /*
   *
   * Project Issue Permissions
   *
   */
  | BaseProjectPermission<ResourceType.ProjectLicensingIssue, ProjectLicensingIssueActions>
  | BaseOrgPermission<ResourceType.ProjectLicensingIssueAny, ProjectLicensingIssueAnyActions>
  | BaseProjectPermission<ResourceType.ProjectQualityIssue, ProjectQualityIssueActions>
  | BaseOrgPermission<ResourceType.ProjectQualityIssueAny, ProjectQualityIssueAnyActions>
  | BaseProjectPermission<ResourceType.ProjectSecurityIssue, ProjectSecurityIssueActions>
  | BaseOrgPermission<ResourceType.ProjectSecurityIssueAny, ProjectSecurityIssueAnyActions>
  /*
   *
   * Project Policy Permissions
   *
   */
  | BaseProjectPermission<ResourceType.ProjectLicensingPolicy, ProjectLicensingPolicyActions>
  | BaseOrgPermission<ResourceType.ProjectLicensingPolicyAny, ProjectLicensingPolicyAnyActions>
  | BaseProjectPermission<ResourceType.ProjectQualityPolicy, ProjectQualityPolicyActions>
  | BaseOrgPermission<ResourceType.ProjectQualityPolicyAny, ProjectQualityPolicyAnyActions>
  | BaseProjectPermission<ResourceType.ProjectSBOMPolicy, ProjectSBOMPolicyActions>
  | BaseOrgPermission<ResourceType.ProjectSBOMPolicyAny, ProjectSBOMPolicyAnyActions>
  | BaseOrgPermission<ResourceType.ProjectSecurityPolicy, ProjectSecurityPolicyOrgActions>
  | BaseOrgPermission<ResourceType.ProjectSecurityPolicyAny, ProjectSecurityPolicyAnyActions>
  /*
   *
   * Project Report Permissions
   *
   */
  | BaseProjectPermission<ResourceType.ProjectLicensingReportPublicLink, ProjectLicensingReportPublicLinkActions>
  | BaseOrgPermission<ResourceType.ProjectLicensingReportPublicLinkAny, ProjectLicensingReportPublicLinkAnyActions>
  /*
   *
   * Policy Permissions
   *
   */
  | BaseOrgPermission<ResourceType.LicensingPolicy, LicensingPolicyOrgActions>
  | BaseOrgPermission<ResourceType.LicensingPolicyAny, LicensingPolicyAnyActions>
  | BaseOrgPermission<ResourceType.SecurityPolicy, SecurityPolicyOrgActions>
  | BaseOrgPermission<ResourceType.SecurityPolicyAny, SecurityPolicyAnyActions>
  | BaseOrgPermission<ResourceType.QualityPolicy, QualityPolicyOrgActions>
  | BaseOrgPermission<ResourceType.QualityPolicyAny, QualityPolicyAnyActions>
  | BaseOrgPermission<ResourceType.SBOMPolicy, SBOMPolicyOrgActions>
  | BaseOrgPermission<ResourceType.SBOMPolicyAny, SBOMPolicyAnyActions>
  /*
   *
   * Release Group CRUD Permissions
   *
   */
  | BaseOrgPermission<ResourceType.ReleaseGroup, ReleaseGroupOrgActions>
  | BaseReleaseGroupPermission<ResourceType.ReleaseGroup, ReleaseGroupActions>
  | BaseOrgPermission<ResourceType.ReleaseGroupAny, ReleaseGroupAnyActions>
  | BaseReleaseGroupPermission<ResourceType.ReleaseGroupRelease, ReleaseGroupReleaseActions>
  | BaseOrgPermission<ResourceType.ReleaseGroupReleaseAny, ReleaseGroupReleaseAnyActions>
  /*
   *
   * Release Group Issue Permissions
   *
   */
  | BaseReleaseGroupPermission<ResourceType.ReleaseGroupLicensingIssue, ReleaseGroupLicensingIssueActions>
  | BaseOrgPermission<ResourceType.ReleaseGroupLicensingIssueAny, ReleaseGroupLicensingIssueAnyActions>
  | BaseReleaseGroupPermission<ResourceType.ReleaseGroupQualityIssue, ReleaseGroupQualityIssueActions>
  | BaseOrgPermission<ResourceType.ReleaseGroupQualityIssueAny, ReleaseGroupQualityIssueAnyActions>
  | BaseReleaseGroupPermission<ResourceType.ReleaseGroupSecurityIssue, ReleaseGroupSecurityIssueActions>
  | BaseOrgPermission<ResourceType.ReleaseGroupSecurityIssueAny, ReleaseGroupSecurityIssueAnyActions>
  /*
   *
   * Release Group Policy Permissions
   *
   */
  | BaseOrgPermission<ResourceType.ReleaseGroupLicensingPolicy, ReleaseGroupLicensingPolicyActions>
  | BaseOrgPermission<ResourceType.ReleaseGroupLicensingPolicyAny, ReleaseGroupLicensingPolicyAnyActions>
  | BaseOrgPermission<ResourceType.ReleaseGroupQualityPolicy, ReleaseGroupQualityPolicyActions>
  | BaseOrgPermission<ResourceType.ReleaseGroupQualityPolicyAny, ReleaseGroupQualityPolicyAnyActions>
  | BaseOrgPermission<ResourceType.ReleaseGroupSecurityPolicy, ReleaseGroupSecurityPolicyActions>
  | BaseOrgPermission<ResourceType.ReleaseGroupSecurityPolicyAny, ReleaseGroupSecurityPolicyAnyActions>
  /*
   *
   * Team Permissions
   *
   */
  | BaseOrgPermission<ResourceType.Team, TeamOrgActions>
  | BaseTeamPermission<ResourceType.Team, TeamActions>
  | BaseOrgPermission<ResourceType.TeamAny, TeamAnyActions>
  | BaseTeamPermission<ResourceType.TeamProject, TeamProjectActions>
  | BaseOrgPermission<ResourceType.TeamProjectAny, TeamProjectAnyActions>
  | BaseTeamPermission<ResourceType.TeamReleaseGroup, TeamReleaseGroupActions>
  | BaseOrgPermission<ResourceType.TeamReleaseGroupAny, TeamReleaseGroupAnyActions>
  | BaseOrgPermission<ResourceType.TeamReport, TeamReportActions>
  | BaseTeamPermission<ResourceType.TeamReportOptionAny, TeamReportOptionAnyActions>
  | BaseTeamPermission<ResourceType.TeamUser, TeamUserActions>
  | BaseOrgPermission<ResourceType.TeamUserAny, TeamUserAnyActions>
  /*
   *
   * User Management Permissions
   *
   */
  | BaseOrgPermission<ResourceType.Role, RoleActions>
  | BaseOrgPermission<ResourceType.User, UserActions>
  | BaseOrgPermission<ResourceType.UserAny, UserAnyActions>
  /*
   *
   * Generate reports
   *
   */
  | BaseProjectPermission<ResourceType.ProjectReport, ProjectReportActions>
  | BaseOrgPermission<ResourceType.ProjectReportAny, ProjectReportAnyActions>
  | BaseReleaseGroupPermission<ResourceType.ReleaseGroupReport, ReleaseGroupReportActions>
  | BaseOrgPermission<ResourceType.ReleaseGroupReportAny, ReleaseGroupReportAnyActions>
  /*
   *
   * Report Option Permissions
   *
   */
  | BaseOrgPermission<ResourceType.ReportOptionAny, ReportOptionAnyActions>
  /*
   *
   * Service Account Permissions
   *
   */
  | BaseOrgPermission<ResourceType.ServiceAccount, ServiceAccountActions>
  | BaseTeamPermission<ResourceType.ServiceAccountTeam, ServiceAccountTeamActions>
  /*
   *
   * Service Account Trust Relationship Permissions
   *
   */
  | BaseOrgPermission<
      ResourceType.OrganizationServiceAccountTrustRelationship,
      OrganizationServiceAccountTrustRelationshipActions
    >
  | BaseTeamPermission<
      ResourceType.TeamServiceAccountTrustRelationship,
      TeamServiceAccountTrustRelationshipActions
    >;
